module.exports = __webpack_public_path__ + "static/media/upset.c5fbb4ae.jpg";